import React from "react";
import { useState } from "react";
import BlogArt from "../components/BlogArt";
import ArticlesList from "../components/NorthArticles/ArticlesList"; 
import DigitalDivide from "../components/NorthArticles/DigitalDivide";


function Blog() {
 
  return (

    <div>
        <BlogArt  />
    </div>
  );
}

export default Blog;
